import { useContext } from "react";

import { ProcessoContext } from "@contexts/ProcessoContext";

import ProcessoService from "@services/ProcessoService";
import AuthorizedFunction from '@security/AuthorizedFunction';

export const ProcessoResolver = (novoProcesso) => {
    const { processo, setProcesso } = useContext(ProcessoContext);

    if(novoProcesso !== undefined){
        if(processo === undefined || processo.id !== novoProcesso){
            ProcessoService.listarUm(novoProcesso).then(resultado => setProcesso(resultado.data));
        }
    }

    return processo;
}

export const ProcessoDetach = () => {
    const { processo, setProcesso } = useContext(ProcessoContext);

    if(processo !== undefined && processo.id !== undefined) {
	    setProcesso({ id: undefined, name: undefined });
    }

    return processo;
}

export const redirectPaginaInicialDeAcordoComPerfil = (history,processo) => {
  if(AuthorizedFunction(["__processo.acompanhamento"])){
    history.push(`/${processo}/acompanhamento`);
  }else if(AuthorizedFunction(["__processo.usuario.portaria"])){
    history.push(`/${processo}/portaria`);
  }else if(AuthorizedFunction(["__processo.usuario.lancadortriagem"])){
    history.push(`/${processo}/Triagem`);
  }else if(AuthorizedFunction(["__processo.usuario.lancadorcontagem"])){
    history.push(`/${processo}/contagem`);
  }else if(AuthorizedFunction(["__processo.usuario.tratamento"])){
    history.push(`/${processo}/pendencias`);
  }else if(AuthorizedFunction(["__processo.usuario.armazenador"])){
    history.push(`/${processo}/armazenar`);
  }else if(AuthorizedFunction(["__processo.usuario.gerencia"])){
    history.push(`/colaboradores`);
  }else if(AuthorizedFunction(["__processo.usuario.scanner"])){
    history.push(`/digitalizacao`);
  }else if(AuthorizedFunction(["__processo.usuario.digitador"])){
    window.location.href = process.env.REACT_APP_DIGITACAO_URL;
  }else{
    history.push(`/${processo}/acompanhamento`);
  }
}
